
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preferred/[[...slug]]",
      function () {
        return require("private-next-pages/preferred/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preferred/[[...slug]]"])
      });
    }
  